export type TemplateSubmissionFlags = {
    allowIncompleteProductLines: boolean
    supplierLetterUploaded: boolean
}

export const TemplateSubmissionFlags_Default = {
    allowIncompleteProductLines: false,
    supplierLetterUploaded: false
} as TemplateSubmissionFlags;
